import React from 'react';

class WaveformVisualizer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bars: Array(40).fill(0) // 40 bars for the visualization
    };
    this.animationFrameId = null;
  }

  componentDidMount() {
    if (this.props.isRecording) {
      this.startAnimation();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isRecording && !prevProps.isRecording) {
      this.startAnimation();
    } else if (!this.props.isRecording && prevProps.isRecording) {
      this.stopAnimation();
    }
  }

  componentWillUnmount() {
    this.stopAnimation();
  }

  stopAnimation = () => {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
    // Reset bars to zero
    this.setState({ bars: Array(40).fill(0) });
  }

  startAnimation = () => {
    this.animateWaveform();
  }

  animateWaveform = () => {
    if (!this.props.isRecording) {
      return;
    }

    // Generate random bar heights to simulate audio levels
    const newBars = Array(40).fill(0).map(() => {
      return Math.random() * 100; // Random height 0-100%
    });

    this.setState({ bars: newBars });
    
    // Update every 100ms for smooth animation
    setTimeout(() => {
      this.animationFrameId = requestAnimationFrame(this.animateWaveform);
    }, 100);
  }

  render() {
    const { isRecording } = this.props;
    const { bars } = this.state;

    return (
      <div className="flex items-center space-x-1 px-2 py-1">
        {bars.map((height, index) => (
          <div
            key={index}
            className="bg-blue-500 transition-all duration-100 ease-out rounded-sm"
            style={{
              width: '3px',
              height: isRecording ? `${Math.max(height * 0.2 + 2, 2)}px` : '2px',
              opacity: isRecording ? 0.8 : 0.3
            }}
          />
        ))}
      </div>
    );
  }
}

export default WaveformVisualizer; 